
import { Info } from "../Icons/Info";
import styles from "./FieldError.module.css";

export interface IFieldErrorProps {
  message?: string;
  error?: boolean;
}

export default function FieldError(props: IFieldErrorProps) {
  return props.error ? <p className={styles.root}><Info />{props.message || "Campo inválido"}</p> : null;
}